import { Link } from "react-router-dom";
import { Building2, Wrench, Flame, Landmark, HardHat } from "lucide-react";

const SOLUTIONS = [
  { Icon: Wrench, title: "Utility Locating", desc: "Run multi-customer, multi-market operations with consistent SLAs and proof of work." },
  { Icon: Building2, title: "Contract Locators", desc: "Win and retain contracts with auditable, customer-specific closeout workflows." },
  { Icon: Flame, title: "Gas & Telecom", desc: "Tight SLAs, damage prevention, and high-evidence requirements — handled by default." },
  { Icon: Landmark, title: "Municipalities", desc: "One unified intake and reporting layer across departments, internal crews, and contractors." },
  { Icon: HardHat, title: "Construction", desc: "Coordinate pre-construction locates, daily standbys, and damage incidents in one place." },
];

export default function Solutions() {
  return (
    <section className="section-y relative">
      <div className="container-x">
        <div className="max-w-3xl reveal">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F97316] mb-3">Solutions</div>
          <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight">
            Built for the way locate work actually runs.
          </h1>
          <p className="mt-5 text-lg text-[#94A3B8] leading-relaxed">
            LocateOS supports every type of operation that touches an underground utility ticket — from in-house utility teams to contract locators.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5">
          {SOLUTIONS.map(({ Icon, title, desc }, i) => (
            <div key={title} className="reveal rounded-2xl glass p-7 hover:-translate-y-1 transition-all" style={{ transitionDelay: `${i * 70}ms` }}>
              <div className="h-12 w-12 rounded-xl bg-[#F97316]/15 border border-[#F97316]/30 grid place-items-center mb-4">
                <Icon size={22} className="text-[#F97316]" />
              </div>
              <h3 className="font-display font-bold text-xl text-white">{title}</h3>
              <p className="mt-2 text-[#94A3B8] leading-relaxed">{desc}</p>
              <Link to="/demo" className="mt-5 inline-flex text-sm font-semibold text-[#F97316] hover:underline">
                See it in action →
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
